import { getUtcDayjs } from "../../types/Date";
import { IFieldDef } from "./FieldInfo";

const CollapsedGroupPrefix = "##CollapsedGroup##";
// Collapsed groups are bound to particular fields, so we need some unique generated ID which
// relates to the field, they are bound to.
export function getCollapsedGroupId(def: IFieldDef | string): string {
    const id = typeof def === "string" ? def : def.id;
    return `${CollapsedGroupPrefix}${id}`;
}

export function getMonthFromDate(date: Date): number {
    if (!date) {
        return null;
    }
    // getMonth returns month from 0 to 11 but BE expects 1 to 12
    return date.getMonth() + 1;
}

export function getDateFromMonth(month: number): Date {
    if (!month) {
        return null;
    }
    // on model the month is 1 to 12 but dayjs expects 0 to 11
    return getUtcDayjs().set("month", month - 1).toDate();
}

